import { z } from "zod"

/**
 * The two kinds of prompt the management screen holds.
 *
 * `mt_prompt` drives the translation pipeline; `assistant_prompt_template` is the rubric the
 * quality assistant measures a conversation against. Same screen, same people, different tables —
 * and of the translation table's ten columns a rubric can fill two.
 */
export const PROMPT_KINDS = [
  { value: "mt", label: "번역 프롬프트", createLabel: "프롬프트 생성" },
  { value: "rubric", label: "평가 기준", createLabel: "평가 기준 생성" },
] as const

export type PromptKind = (typeof PROMPT_KINDS)[number]["value"]

export const promptSearchSchema = z.object({
  /**
   * In the URL because "which kind am I looking at" is what gets pasted into Slack.
   *
   * `.catch` rather than a bare parse: a stale bookmark or a hand-typed `?kind=whatever` should
   * land on the default list, not throw into an error boundary — which is what the neighbouring
   * admin/user route does with the same shape.
   */
  kind: z.enum(["mt", "rubric"]).optional().catch(undefined),
})

/** What the tab strip shows for a given search, including one that is missing or nonsense. */
export const kindFromSearch = (search: unknown): PromptKind =>
  promptSearchSchema.parse(search).kind ?? "mt"

export const promptKind = (kind: PromptKind) =>
  PROMPT_KINDS.find((entry) => entry.value === kind) ?? PROMPT_KINDS[0]
